module.exports = require('./dist/base64url').default;
module.exports.default = module.exports;



//////////////////
// WEBPACK FOOTER
// ./~/base64url/index.js
// module id = 690
// module chunks = 0